import { useMutation, useQueryClient } from 'react-query'
import vehiclesApi from './actions'
import { vehiclesKeys } from './constants'

const useVehiclesMutations = (companyId: number) => {
  const queryClient = useQueryClient()

  const createVehicle = useMutation(vehiclesApi.createVehicle, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(vehiclesKeys.root(companyId))
    },
  })

  const updateVehicle = useMutation(vehiclesApi.updateVehicle, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(vehiclesKeys.root(companyId))
    },
  })

  const deleteVehicle = useMutation(vehiclesApi.deleteVehicle, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(vehiclesKeys.root(companyId))
    },
  })

  return { createVehicle, updateVehicle, deleteVehicle }
}

export default useVehiclesMutations
